export const EST_IDS = {
  estimatingPage: 'estimating-page',
  financialSummary: 'estimating-financial-summary',
  typeCard: (t) => `estimate-card-${t}`,
  importButton: (t) => `import-${t}-button`,
  templateButton: (t) => `download-template-${t}-button`,
  versionRow: 'estimate-version-row',
  importDialog: 'estimate-import-dialog',
  fileInput: 'estimate-file-input',
  expectedInput: 'estimate-expected-input',
  validationErrors: 'estimate-validation-errors',
  validationWarnings: 'estimate-validation-warnings',
  previewTable: 'estimate-preview-table',
  reconciliationCard: 'estimate-reconciliation-card',
  reconciliationMatch: 'estimate-reconciliation-match',
  reconciliationMismatch: 'estimate-reconciliation-mismatch',
  overrideReason: 'estimate-override-reason',
  confirmButton: 'estimate-confirm-button',
  cancelButton: 'estimate-cancel-button',
  importError: 'estimate-import-error',
  viewerPage: 'estimate-viewer-page',
  viewerFilter: 'estimate-viewer-filter',
  viewerDownload: 'estimate-viewer-download',
  rejectButton: 'estimate-reject-button',
  discardButton: 'estimate-discard-button',
  rejectReason: 'estimate-reject-reason',
  refDocsSection: 'reference-docs-section',
  refDocUpload: 'reference-doc-upload-input',
  refDocRow: 'reference-doc-row',
  refDocDownload: 'reference-doc-download',
  refDocRemove: 'reference-doc-remove',
};
